// extracted by mini-css-extract-plugin
export default {"wrapper":"Keywords_wrapper__tK9+H"};